var map = {
	"./backgrounds/fall.jpg": "a9e3",
	"./backgrounds/ground-tile-fall.jpg": "13bb",
	"./backgrounds/ground-tile-spring.jpg": "24e2",
	"./backgrounds/ground-tile-summer.jpg": "2c98",
	"./backgrounds/ground-tile-winter.jpg": "9ff0",
	"./backgrounds/spring.jpg": "73ed",
	"./backgrounds/summer.jpg": "3ef7",
	"./backgrounds/winter.jpg": "2589",
	"./badges/badge-icon.svg": "ff92",
	"./badges/grey-badge.png": "73c1",
	"./badges/happy-habitat-badge.png": "c4c9",
	"./badges/moose-manager-badge.png": "dc28",
	"./badges/mousekateer-badge.png": "3e14",
	"./badges/super-spruce-badge.png": "eb21",
	"./badges/twig-cafe-badge.png": "1020",
	"./badges/water-bender-badge.png": "d0ee",
	"./data": "186a",
	"./data/": "186a",
	"./data/about-moose": "3251",
	"./data/about-moose.json": "3251",
	"./data/game/badges": "86d9",
	"./data/game/badges.json": "86d9",
	"./data/game/element-intros": "85bd",
	"./data/game/element-intros.json": "85bd",
	"./data/game/elements": "91ad",
	"./data/game/elements.json": "91ad",
	"./data/game/event-sequence": "076c",
	"./data/game/event-sequence.json": "076c",
	"./data/game/events": "1480",
	"./data/game/events.json": "1480",
	"./data/game/moose": "225e",
	"./data/game/moose.json": "225e",
	"./data/game/seasons": "0ad3",
	"./data/game/seasons.json": "0ad3",
	"./data/game/text": "faf5",
	"./data/game/text.json": "faf5",
	"./data/global-content": "e05d",
	"./data/global-content.json": "e05d",
	"./data/index": "186a",
	"./data/index.json": "186a",
	"./data/research": "7f06",
	"./data/research.json": "7f06",
	"./ecosystem/aspen-fall-icon.png": "1445",
	"./ecosystem/aspen-fall.png": "f580",
	"./ecosystem/aspen-spring-icon.png": "129d",
	"./ecosystem/aspen-spring.png": "07d7",
	"./ecosystem/aspen-summer-icon.png": "73b9",
	"./ecosystem/aspen-summer.png": "de32",
	"./ecosystem/aspen-winter-icon.png": "4d6f",
	"./ecosystem/aspen-winter.png": "02e7",
	"./ecosystem/bull.png": "8c66",
	"./ecosystem/calf.png": "43df",
	"./ecosystem/cow.png": "d175",
	"./ecosystem/deer-icon.png": "2224",
	"./ecosystem/deer.png": "37eb",
	"./ecosystem/parasites-1.png": "d946",
	"./ecosystem/parasites-2.png": "f9e6",
	"./ecosystem/parasites-3.png": "0ec6",
	"./ecosystem/pond-fall-icon.png": "0c67",
	"./ecosystem/pond-fall.png": "c09d",
	"./ecosystem/pond-spring-icon.png": "cbc2",
	"./ecosystem/pond-spring.png": "d986",
	"./ecosystem/pond-summer-icon.png": "6bae",
	"./ecosystem/pond-summer.png": "90dd",
	"./ecosystem/pond-winter-icon.png": "3686",
	"./ecosystem/pond-winter.png": "a46d",
	"./ecosystem/spruce-fall-icon.png": "9762",
	"./ecosystem/spruce-fall.png": "0a0c",
	"./ecosystem/spruce-spring-icon.png": "e0a5",
	"./ecosystem/spruce-spring.png": "1a69",
	"./ecosystem/spruce-summer-icon.png": "548c",
	"./ecosystem/spruce-summer.png": "b497",
	"./ecosystem/spruce-winter-icon.png": "3516",
	"./ecosystem/spruce-winter.png": "c391",
	"./ecosystem/wolf-icon.png": "f3fb",
	"./ecosystem/wolf-infected.png": "b6dd",
	"./ecosystem/wolf.png": "ec46",
	"./icons/arrow-icon-blue.svg": "b7ea",
	"./icons/arrow-icon-short.svg": "d180",
	"./icons/arrow-icon-white.svg": "361f",
	"./icons/arrow-icon-yellow.svg": "a410",
	"./icons/arrow-icon.svg": "76ea",
	"./icons/deer-intro-icon.png": "3f1e",
	"./icons/go-arrow-small.svg": "58f3",
	"./icons/go-arrow.svg": "1212",
	"./icons/hole-icon.svg": "3fe5",
	"./icons/hole-mask.svg": "64cc",
	"./icons/home-icon.svg": "8f3c",
	"./icons/icon-x.svg": "9748",
	"./icons/info-icon.svg": "2656",
	"./icons/menu-close-white.svg": "ea94",
	"./icons/menu-close.svg": "b225",
	"./icons/menu-icon.svg": "b43c",
	"./icons/resource-intro-icon.png": "1415",
	"./icons/season-dial.png": "1594",
	"./icons/season-highlight.svg": "3eca",
	"./icons/sound-off-icon.svg": "6932",
	"./icons/sound-on-icon.svg": "77e6",
	"./icons/triangle-icon.svg": "047b",
	"./icons/wolf-intro-icon.png": "fe49",
	"./images/diagram-line-antlers.png": "8ac5",
	"./images/diagram-line-coat.png": "39c9",
	"./images/diagram-line-legs.png": "9524",
	"./images/diagram-line-snout.png": "15e9",
	"./images/moose-tracks.png": "4180",
	"./images/play-bg-hover.png": "1090",
	"./images/play-bg.png": "5cad",
	"./sfx/event_construction.mp3": "cf03",
	"./sfx/event_deer-intro.mp3": "2fc9",
	"./sfx/event_more-wolves.mp3": "b3c0",
	"./sfx/event_severe-winter.mp3": "9ba9",
	"./sfx/event_timber.mp3": "29fc",
	"./sfx/event_wildfire.mp3": "49f2",
	"./sfx/event_wolf-intro.mp3": "4c56",
	"./sfx/play_event_badge.mp3": "13bbb",
	"./sfx/play_event_ending.mp3": "c04a",
	"./sfx/play_event_moose-add.mp3": "a28a",
	"./sfx/play_event_moose-remove.mp3": "7966",
	"./sfx/play_event_notice.mp3": "9b9f",
	"./sfx/play_event_parasites.mp3": "d782",
	"./sfx/play_event_threshold.mp3": "5096",
	"./sfx/season_fall.mp3": "7c35",
	"./sfx/season_spring.mp3": "631d",
	"./sfx/season_summer.mp3": "d3e0",
	"./sfx/season_winter.mp3": "0b19",
	"./sfx/ui_click.mp3": "9104"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";